<div class="connections-list">
  <div class="table-container">
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z0"
           [hidden]="dataSource.data.length === 0">

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
        <td mat-cell *matCellDef="let item">
          <span class="name-cell">
            <a [href]="getEntityUrl(item)" class="company-link-btn" [title]="'Open ' + getConnectionTypeText(item.type)">
              <mat-icon>open_in_new</mat-icon>
            </a>
            {{ item.name }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
        <td mat-cell *matCellDef="let item">
          <span class="type-badge" [ngClass]="Helpers.getEntityTypeBadgeClass(getConnectionTypeText(item.type))">
            {{ getConnectionTypeText(item.type) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let item">
          <button mat-icon-button color="warn" (click)="onDelete(item.id)" class="action-btn">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    @if (dataSource.data.length === 0) {
      <div class="empty-state">No connections available</div>
    }

    <mat-paginator
      [pageSize]="10"
      [pageSizeOptions]="[5, 10, 25, 100]"
      [showFirstLastButtons]="true"
      [hidden]="dataSource.data.length === 0"
      aria-label="Select page">
    </mat-paginator>
  </div>
</div>
